/*
 * File: DemographicsLinks.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 10/01/2018
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates the links for the demographic page
 */
import React from "react";
import UILinkList from "components/ui/UILinkList";
import PatientId from "services/patients/store/PatientIdStore";

const DemographicLinks = () => {
  const patientId = PatientId.getId();
  const demographicURL = "/patients/" + patientId + "/demographics/";
  const demographicLinks = [
    {
      primaryString: "Patient Information",
      url: demographicURL + "patient_information"
    },
    {
      primaryString: "Balances",
      url: demographicURL + "balances"
    },
    {
      primaryString: "Alerts",
      url: demographicURL + "alerts"
    },
    {
      primaryString: "Provider, Office, & Fee Schedule",
      url: demographicURL + "provider_office_fee"
    },
    {
      primaryString: "Emergency Contact",
      url: demographicURL + "emergency_contact"
    }
  ];

  return <UILinkList links={demographicLinks} />;
};

export default DemographicLinks;
